/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-var */

const cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

// copying from polished github repostiory at https://github.com/styled-components/polished/blob/main/src/helpers/stripUnit.js
/**
 * Returns a given CSS value minus its unit of measure.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value: string | number): string | number {
  if (typeof value !== 'string') return value;
  const matchedValue = value.match(cssRegex);
  return matchedValue ? parseFloat(value) : value;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */
class PolishedError extends Error {
  constructor(code: string | number, ...args: Array<unknown>) {
    super(
      `An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#${code} for more information.`,
    );
  }
}

// copied from polished github repostiory at https://github.com/styled-components/polished/blob/main/src/internalHelpers/_endsWith.js
/**
 * Check if a string ends with something
 * @private
 */
function endsWith(string: string, suffix: string): boolean {
  return string.substr(-suffix.length) === suffix;
}

// copied from polished github repostiory at https://github.com/styled-components/polished/blob/main/src/internalHelpers/_pxto.js
/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
const pxtoFactory =
  (to: string) =>
  (pxval: string | number, base: string | number = '16px'): string => {
    let newPxval = pxval;
    let newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new PolishedError(69, to, pxval);
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new PolishedError(70, to, base);
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new PolishedError(71, pxval, to);
    }

    if (typeof newBase === 'string') {
      throw new PolishedError(72, base, to);
    }

    return `${newPxval / newBase}${to}`;
  };

// copied from polished github repostiory at https://github.com/styled-components/polished/blob/main/src/helpers/rem.js
/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */
export const rem: (value: string | number, base?: string | number) => string = pxtoFactory('rem');
